import './App.css';
import WhiteHeader from "./components/whiteHeader";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProjectPage from "./pages/ProjectPage";
import MainPage from "./pages/MainPage";
import { motion } from "framer-motion";
import {useRef } from "react";
import Sertifika from "./pages/Sertifika";


function App() {
    const kurumsalRef = useRef(null);
    const projelerRef = useRef(null);
    const kariyerRef = useRef(null);
    const iletisimRef = useRef(null);
    const politicsRef = useRef(null);
    const refs = [kurumsalRef, projelerRef, kariyerRef, iletisimRef, politicsRef];
    return (
        <BrowserRouter>
            <div
                className="App">
                <WhiteHeader scrollTargetRef={[kurumsalRef, projelerRef, kariyerRef, iletisimRef, politicsRef]}></WhiteHeader>
                <Routes>
                    <Route path="/" element={
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 1 }}
                        >
                            <MainPage scrollTargetRef={refs} />
                        </motion.div>
                    } />
                    <Route path="/projeler/:slug" element={<ProjectPage />} />
                    <Route path="/sertifika" element={<Sertifika />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
}

export default App;
